import React from "react";
import Heading from "../../heading/heading";
import Program from "./program";
import "./programs.css";
import list from "./listPrograms";

function Programs() {
  return (
    <div className="main">
      <Heading title="Programs" />

      <div className="programs">
        {list.map((item) => (
          <Program
            key={item.id}
            img={item.img}
            para={item.para}
            title={item.title}
          />
        ))}
      </div>
    </div>
  );
}

export default Programs;
